import { TranslationKey, useInterfaceLanguage } from '@/shared/i18n';

import { Bullet, CheckIcon, Container } from './styled';

export const BULLETS: TranslationKey[] = ['pricing.buyMinutes.benefitRemain', 'pricing.buyMinutes.benefitRollOver'];

export const Benefits = () => {
  const { t } = useInterfaceLanguage();

  return (
    <Container>
      {BULLETS.map((bullet) => (
        <Bullet key={bullet}>
          <CheckIcon width={20} />
          {t(bullet)}
        </Bullet>
      ))}
    </Container>
  );
};
